exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transition[data-v-67b68d18]{-webkit-transition:all .2s ease;transition:all .2s ease}", ""]);

// exports
